// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 创建角色 POST /apiAdmin/role */
export async function roleControllerCreateRole(
  body: API.CreateRoleDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataRoleDataDtoDto>("/apiAdmin/role", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据ID获取角色 GET /apiAdmin/role/${param0} */
export async function roleControllerGetRoleById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerGetRoleByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataRoleDataDtoDto>(`/apiAdmin/role/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 更新角色 PUT /apiAdmin/role/${param0} */
export async function roleControllerUpdateRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerUpdateRoleParams,
  body: API.UpdateRoleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataRoleDataDtoDto>(`/apiAdmin/role/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除角色 DELETE /apiAdmin/role/${param0} */
export async function roleControllerDeleteRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerDeleteRoleParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/role/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取角色及其权限 GET /apiAdmin/role/${param0}/permissions */
export async function roleControllerGetRoleWithPermissions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerGetRoleWithPermissionsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataRoleWithPermissionsDtoDto>(
    `/apiAdmin/role/${param0}/permissions`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 分配权限 POST /apiAdmin/role/${param0}/permissions */
export async function roleControllerAssignPermissions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerAssignPermissionsParams,
  body: API.AssignPermissionsDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/role/${param0}/permissions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 获取所有角色（不分页） GET /apiAdmin/role/all */
export async function roleControllerGetAllRoles(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.RoleControllerGetAllRolesParams,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataRoleDataDtoArrayDto>("/apiAdmin/role/all", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取角色列表（分页） POST /apiAdmin/role/list */
export async function roleControllerGetRoleList(
  body: API.QueryRoleDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataRoleDataDtoPageDto>("/apiAdmin/role/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
